export const TOOL_NAME_BUILD_CHART = 'buildChart';
export const TOOL_NAME_BUILD_DASHBOARD = 'buildDashboard';
export const TOOL_NAME_BUILD_DATA_MODEL = 'buildDataModel';
export const TOOL_NAME_RECOMMEND_QUERIES = 'recommendQueries';
export const TOOL_NAME_GET_DASHBOARDS = 'getDashboards';
export const TOOL_NAME_GET_DATA_SOURCES = 'getDataSources';
export const TOOL_NAME_GET_DATA_SOURCE_FIELDS = 'getDataSourceFields';
export const TOOL_NAME_BUILD_QUERY = 'buildQuery';
export const TOOL_NAME_LIST_DATA_MODELS = 'listDataModels';
export const TOOL_NAME_GET_MODEL_SCHEMA = 'getModelSchema';
export const TOOL_NAME_ADD_RELATION = 'addRelation';
export const TOOL_NAME_REMOVE_RELATION = 'removeRelation';
export const TOOL_NAME_CREATE_PERSPECTIVE = 'createPerspective';
export const TOOL_NAME_UPDATE_PERSPECTIVE = 'updatePerspective';
export const TOOL_NAME_GET_PERSPECTIVE = 'getPerspective';
export const TOOL_NAME_TRIGGER_BUILD = 'triggerBuild';
export const TOOL_NAME_LIST_PERSPECTIVES = 'listPerspectives';
export const TOOL_NAME_UPLOAD_FILES = 'uploadFiles';
export const TOOL_NAME_BUILD_CSV_MODEL = 'buildDataModelFromUploads';

/** Debug label for `engineCall` traces (e.g. `buildChart` → `buildChartEngine`). */
export const toEngineName = (toolName: string) => toolName + 'Engine';

// limit the number of assets to consider to keep the tool system prompt not too long
export const TOOL_CONTEXT_MAX_ASSETS = 10;

// Limit the number of fields in data source fields summary to prevent token overflow
export const MAX_DATA_SOURCE_FIELDS_SUMMARY = 200;

// Limit the number of shared formulas in data source summary for the LLM
export const MAX_DATA_SOURCE_FORMULAS_SUMMARY = 50;

// This is a placeholder for the backend to override with the actual model to use
export const DEFAULT_LLM = 'LLM_PLACEHOLDER';

// User action tracking headers (W3C traceparent, quota, etc.)
export const HEADER_USER_ACTION_ID = 'x-user-action-id';
export const HEADER_TRACEPARENT = 'traceparent';
export const HEADER_INTERFACE_NAME = 'x-interface-name';
export const HEADER_FEATURE_NAME = 'x-feature-name';
export const HEADER_QUOTA_ID = 'x-quota-id';

export const ALLOWED_HEADERS = [
	HEADER_USER_ACTION_ID,
	HEADER_TRACEPARENT,
	HEADER_INTERFACE_NAME,
	HEADER_FEATURE_NAME,
	HEADER_QUOTA_ID,
];
